<template>
  <div :class="elementClass">
    <slot></slot>
  </div>
</template>

<script>
import { listClass } from "../prefix";
export default {
  props: {
    parentEl: {
      default: null,
    },
  },
  data() {
    return {
      isHide: false,
    };
  },
  computed: {
    elementClass() {
      return [listClass, this.parentEl ? "has-parent" : ""];
    },
  },
  methods: {
    hide() {
      this.$el.style.maxHeight = "0";
      this.parentEl.close();
      this.isHide = true;
    },
    show() {
      this.$el.style.maxHeight = this.$el.scrollHeight + "px";
      this.parentEl.open();
      this.isHide = false;
    },
    toggle() {
      this.isHide ? this.show() : this.hide();
    },
    checkHasParentAndHide() {
      if (this.parentEl) {
        this.hide();
        this.parentEl.$el.removeEventListener("click", this.clickEvent);
        this.parentEl.$el.addEventListener("click", this.clickEvent);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkHasParentAndHide();
      this.clickEvent = () => {
        this.toggle();
      };
    });
  },
  watch: {
    parentEl() {
      this.checkHasParentAndHide();
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-list";

#{$element} {
  #{$element}-item {
    min-height: 40px;
    width: 100%;
    padding: 8px 16px;
    @include transition(all 0.2s $animation-deceleration-curve-timing-function);
    cursor: pointer;
    @include unselectable();
    color: $color-grey-900;

    &:hover {
      background: $theme-primary-50;
      color: $theme-primary;
    }

    .main-text {
      height: 24px;
      line-height: 24px;
      display: inline-block;
      vertical-align: middle;
      font-size: 13px;
    }

    .first-icon,
    .second-icon {
      display: inline-block;
      vertical-align: middle;
      // height: 32px;
      & > * {
        height: 32px;
        line-height: 32px;
        margin-right: 16px;
        svg > path {
          fill: $color-grey-500 !important;
        }
      }
    }

    .second-icon {
      float: right;
      & > * {
        margin-right: 0;
        @include transition(all 0.2s $animation-deceleration-curve-timing-function);
      }

      &.open {
        & > * {
          @include transform(rotate(-90deg));
        }
      }
    }

    &.active {
      background: $theme-primary-gradient-1;
      color: white;
      .first-icon,
      .second-icon {
        display: inline-block;
        vertical-align: middle;
        // height: 32px;
      }
    }
  }

  &.has-parent {
    overflow: hidden;
    @include transition(all 0.2s $animation-deceleration-curve-timing-function);
    #{$element}-item {
      padding-left: 56px;
    }
  }
}

.router-link-exact-active {
  #{$element}-item {
    color: $theme-primary;
    &:hover {
      background: rgba($theme-primary, 0.2);
    }

    .first-icon > *,
    .second-icon > * {
      color: $theme-primary !important;
      svg > path {
        fill: $theme-primary !important;
      }
    }
  }
}
</style>
